import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * GLOBAL sales-side community selection (SkyCRM only). Holds the user's app-wide community filter
 * choice; `null` = "All communities" (instance-wide data + personal tz). Mirrors the instance
 * pattern (instancesSlice): app-wide, survives navigation. Read via useSelectedCommunity().
 *
 * Plumbing only at this stage — no surface reads it for behavior yet (the header control + the
 * filter/tz wiring land in later rounds). Not persisted across full reload (a later decision).
 */
export interface CommunityState {
  selectedCommunityId: string | null;
}

const initialState: CommunityState = {
  selectedCommunityId: null,
};

const communitySlice = createSlice({
  name: "community",
  initialState,
  reducers: {
    setSelectedCommunity: (state, action: PayloadAction<string | null>) => {
      state.selectedCommunityId = action.payload;
    },
    clearSelectedCommunity: (state) => {
      state.selectedCommunityId = null;
    },
    resetCommunityState: () => initialState,
  },
});

export const { setSelectedCommunity, clearSelectedCommunity, resetCommunityState } =
  communitySlice.actions;

export default communitySlice.reducer;
